import { configureStore } from '@reduxjs/toolkit';
import discussionReducer from './discussionSlice';
import viewportReducer from './viewportSlice';

// See https://redux.js.org/usage/usage-with-typescript
export const store = configureStore({
  reducer: {
    discussion: discussionReducer,
    viewport: viewportReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
